import React from 'react';
import { connect } from 'react-redux';
import Moment from 'moment';

import EditMenu from './EditMenu';
import NameAvatar from './NameAvatar';

import {
  mergeRequestDialog,
  setCollectiveActive,
  resetCollectiveReportButton
} from '../actions';

import FlatButton from 'material-ui/FlatButton';
import IconMenu from 'material-ui/IconMenu';
import IconButton from 'material-ui/IconButton';
import Divider from 'material-ui/Divider';
import MenuItem from 'material-ui/MenuItem';
import Checkbox from 'material-ui/Checkbox';

import css from './contactsTable.css';

// Icons
import NavigationMoreVert from 'material-ui/svg-icons/navigation/more-vert';
import CommunicationPhone from 'material-ui/svg-icons/communication/phone';
import HardwareSmartphone from 'material-ui/svg-icons/hardware/smartphone';

const getEmailButton = (contact) => {
  if (!contact || !contact.email) return '';

  return <a href={`mailto:${contact.email}`}>{contact.email}</a>;
};

const tableStyles = {
  attributes: {
    fontSize: '14px',
  },
  icon: {
    width: '16px',
    height: '16px',
  },
};

function CollectiveListItem(props) {
  const { currentUser, collective, handleEditCollective, openCollectiveDeleteWarning, active } = props;
  return (
    <tr style={{ borderTop: '1px solid #ddd' }}>
      <td>
        <Checkbox
          style={{ marginLeft: 20 }}
          checked={active || false}
          onCheck={props.handleChecked.bind(this, collective.id)}
        />
      </td>
      <td className={css.avatar} onTouchTap={props.handleViewCollectiveDetails.bind(this, collective.id)}>
      <NameAvatar
        id={collective.id}
        name={collective.name}
      />
      </td>
      <td onTouchTap={props.handleViewCollectiveDetails.bind(this, collective.id)}>
        <h4 className={css.title}>{collective.name}</h4>
        <p className={css.subtitle}>Influencers: {collective.influencersCount}</p>
        <p className={css.subtitle}>{collective.parentName}</p>
      </td>
      <td style={tableStyles.attributes}>
        {getEmailButton(collective.contact)}
      </td>
      {collective.contact && collective.contact.phone
        ?
        <td style={tableStyles.attributes}>
          <CommunicationPhone className={css.icon} style={tableStyles.icon}/>
          <a href={`tel:${collective.contact.phone}`}>{collective.contact.phone}</a>
        </td>
        :
        <td></td>
      }
      {collective.contact && collective.contact.mobile
        ?
        <td style={tableStyles.attributes}>
          <HardwareSmartphone className={css.icon} style={tableStyles.icon}/>
          <a href={`tel:${collective.contact.mobile}`}>{collective.contact.mobile}</a>
        </td>
        :
        <td></td>
      }
      <td style={tableStyles.attributes}>
        {Moment(collective.updatedAt).format('MMM Do, YYYY')}
      </td>
      <td>
        <EditMenu
          handleEdit={handleEditCollective.bind(this, collective.id)}
          handleRemove={openCollectiveDeleteWarning.bind(this, collective.id)}
          handleMergeRequest={props.onMergeRequest.bind(this, collective.id)}
        />
      </td>
    </tr>
  );
}

function mapStateToProps(state, ownProps) {
  return {
    active: state.get('collectives').get('items').get(ownProps.collective.id.toString()).get('active'),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onMergeRequest: function (id) {
      dispatch(mergeRequestDialog(id));
    },

    handleChecked: function (id, e, isChecked) {
      dispatch(setCollectiveActive(id, isChecked));
      dispatch(resetCollectiveReportButton());
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CollectiveListItem);



/** WEBPACK FOOTER **
 ** ./components/CollectiveListItem.js
 **/